import React from 'react';
import { SignupStep } from 'src/components/selfService/features/Signup/context/SignupStatusProvider/SignupStatusProvider';
import { BusinessDetailsConfirmationCard } from 'src/components/selfService/features/Signup/steps/ConfirmationStep/BusinessDetailsConfirmationCard/BusinessDetailsConfirmationCard';
import { ValidationSummaryCard } from 'src/components/selfService/features/Signup/steps/ConfirmationStep/ValidationSummaryCard/ValidationSummaryCard';
import { LineOfCreditConfirmationCard } from 'src/components/selfService/features/Signup/steps/ConfirmationStep/LineOfCreditConfirmationCard/LineOfCreditConfirmationCard';
import { PeopleConfirmationCard } from 'src/components/selfService/features/Signup/steps/ConfirmationStep/PeopleConfirmationCard/PeopleConfirmationCard';

interface IConfirmationStepCardProps {
  stepId: SignupStep;
  onDataLoaded: () => void;
  setNumberOfPeople: (numPeople: number) => void;
  setBudgetAmountWithFeeAdded: (budgetAmountWithFeeAdded: number) => void;
}

export function ConfirmationStepCard({
  stepId,
  onDataLoaded,
  setBudgetAmountWithFeeAdded,
  setNumberOfPeople,
}: IConfirmationStepCardProps): JSX.Element {
  switch (stepId) {
    case SignupStep.COMPANY: {
      return <BusinessDetailsConfirmationCard onDataLoaded={onDataLoaded} />;
    }
    case SignupStep.VALIDATION: {
      return <ValidationSummaryCard onDataLoaded={onDataLoaded} />;
    }
    case SignupStep.BUDGET: {
      return (
        <LineOfCreditConfirmationCard
          setBudgetAmountWithFeeAdded={setBudgetAmountWithFeeAdded}
          onDataLoaded={onDataLoaded}
        />
      );
    }
    case SignupStep.PEOPLE: {
      return (
        <PeopleConfirmationCard
          setNumberOfPeople={setNumberOfPeople}
          onDataLoaded={onDataLoaded}
        />
      );
    }
    default: {
      return null;
    }
  }
}
